import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common-layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Grid = _resolveComponent("Grid")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_User = _resolveComponent("User")!
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_Histogram = _resolveComponent("Histogram")!
  const _component_LocationFilled = _resolveComponent("LocationFilled")!
  const _component_Scissor = _resolveComponent("Scissor")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_ElSpace = _resolveComponent("ElSpace")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              justify: "space-between",
              style: {"width":"100%"},
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu, {
                      "default-active": _ctx.activeIndex,
                      onSelect: _ctx.handleSelect,
                      mode: "horizontal",
                      "text-color": "#ffffff",
                      "active-text-color": "#ffffff",
                      "background-color": "transparent",
                      router: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, {
                          ref: "appList",
                          index: "/app/list",
                          disabled: _ctx.appStatus,
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Grid)
                              ]),
                              _: 1
                            }),
                            _cache[0] || (_cache[0] = _createElementVNode("span", null, "App", -1))
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _withDirectives(_createVNode(_component_el_menu_item, {
                          ref: "user",
                          index: "/user/list",
                          disabled: _ctx.userStatus,
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_User)
                              ]),
                              _: 1
                            }),
                            _cache[1] || (_cache[1] = _createElementVNode("span", null, "User", -1))
                          ]),
                          _: 1
                        }, 8, ["disabled"]), [
                          [_vShow, _ctx.userShow]
                        ]),
                        _createVNode(_component_el_menu_item, {
                          ref: "manufacturer",
                          index: "/manufacturer/list",
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_OfficeBuilding)
                              ]),
                              _: 1
                            }),
                            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Manufacturer", -1))
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_el_menu_item, {
                          ref: "developer",
                          index: "/developer/list",
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_UserFilled)
                              ]),
                              _: 1
                            }),
                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Developer", -1))
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_el_menu_item, {
                          ref: "stat",
                          index: "/stat/info",
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Histogram)
                              ]),
                              _: 1
                            }),
                            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Stat", -1))
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_el_menu_item, {
                          ref: "statCountry",
                          index: "/stat/country",
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_LocationFilled)
                              ]),
                              _: 1
                            }),
                            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Country", -1))
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_el_menu_item, {
                          ref: "spider",
                          index: "/spider/list",
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Scissor)
                              ]),
                              _: 1
                            }),
                            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Spider", -1))
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    }, 8, ["default-active", "onSelect"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _ctx.logoutHandle,
                  id: "logout-button",
                  class: "logout-btn",
                  size: "medium"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElSpace, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_SwitchButton)
                          ]),
                          _: 1
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("span", null, "Logout", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}